import _debounce from 'lodash/debounce'
import { useRef } from 'react'

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const useDebounce = (func: (...args: any[]) => any, delay: number) => useRef(_debounce(func, delay)).current

export default useDebounce
